import { ref } from '@nuxtjs/composition-api';
import advertisingContent from '@/content/media/advertising';

const isInitiated = ref(false);

const radioList = ref();
const streamingList = ref();
const podcastList = ref();
const smartSpeakerList = ref();

const setupHook = () => {
  isInitiated.value = true;
  radioList.value = advertisingContent.RADIO.channel;
  streamingList.value = advertisingContent.STREAMING.channel;
  podcastList.value = advertisingContent.PODCASTS.channel;
  smartSpeakerList.value = advertisingContent.SMART_SPEAKER.channel;
};

const useMediaStation = () => {
  if (!isInitiated.value) {
    isInitiated.value = true;
    setupHook();
  }

  return {
    radioList,
    streamingList,
    podcastList,
    smartSpeakerList,
  };
};

export default useMediaStation;
